module.exports = __webpack_public_path__ + "static/img/joinUs_06_m.49b5d851.jpg";